import { theme } from 'antd';
var useToken = theme.useToken;
export { useToken };
//# sourceMappingURL=useToken.js.map